export const API_URL =
  process.env.REACT_APP_API_URL ?? "https://api-ws.srisailadevasthanam.org/";
export const RAZOR_PAY =
  process.env.REACT_APP_RAZOR_PAY ?? "rzp_live_rVhrM3vwtmDPXX";
export const BASE_BANK = "hdfc"
//hdfc-"dev": "cross-env REACT_APP_API_URL=https://ts-api.srisailadevasthanam.org/ REACT_APP_RAZOR_PAY=rzp_test_LFWpeaVVcjKAHd react-scripts start"
//axis-"dev": "cross-env REACT_APP_API_URL=https://ts-api.srisailadevasthanam.org/ REACT_APP_RAZOR_PAY=rzp_test_QLZGj9lA7F2ex7 react-scripts start"
